module.exports = __webpack_public_path__ + "d75169f2216159729f698626716f5af4.svg";